import { render, staticRenderFns } from "./PurchaseV2.vue?vue&type=template&id=1119d4f6"
import script from "./PurchaseV2.vue?vue&type=script&lang=js"
export * from "./PurchaseV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports